var progress = require('../components/progress');

function initializeEvents() {
	const $form = $('form.marketingpreferences');
	$form.on('click', 'button.save', function (event) {
		event.preventDefault();
		$('.multichoices-field').each(function() {
			let fieldValues = [];
			$(this).find('input.checkbox:checked').each(function() {
				fieldValues.push(this.value);
			});
			$(this).find('input.hidden-field').val(fieldValues.join('|'));
		});
		if ($form.valid()) {
			progress.show($form);

			var array = $form.serializeArray();
			var action = $form.data("action");
			var submitData = {};
			$.each(array, function () {
				submitData[this.name] = this.value || "";
			});

			$.ajax({
				type: "POST",
				url: action,
				data: submitData,
				success: function () {
					$(".marketingpreferences-main").hide();
					$(".marketingpreferences-success").show();
				},
				error: function () {
					$(".marketingpreferences-main").hide();
					$(".marketingpreferences-failure").show();
				}
			});
		}
	});
}

const marketingPreferences = {
	init: function () {
		initializeEvents();
	}
};


module.exports = marketingPreferences;
